export enum TravelerInformationState {
  idle = "idle",
  loading = "loading",
  travelerPicker = "travelerPicker",
  travelerForm = "travelerForm",
  error = "error",
}

export enum TravelerInformationChildState {
  idle = "idle",
  new = "new",
  edit = "edit",
  update = "update",
  delete = "delete",
  add = "add",
  route = "route",
  fetch = "fetch",
}
